import { ReactElement, ReactNode, useCallback } from 'react';

import { ActionBar, ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';
import { protectFeature } from '~libs.shared.system';

import { calendarTranslationKeys } from '../../translations';

type CalendarActionBarProps = {
   readonly children: ReactNode;
   readonly waitlistEntryId: number | undefined;
};

export const CalendarActionBar = (props: CalendarActionBarProps): ReactElement => {
   const push = useHistoryPushWithBackAction(false);
   const handleClick = useCallback(() => {
      push(visitPaths.CALENDAR_WAITLIST_PATH, { label: calendarTranslationKeys.goBackToCalendar });
   }, [push]);

   // TODO DREGAB-27120
   if (protectFeature('experimental', false, true)) {
      return <>{props.children}</>;
   }

   return (
      <ActionBar id='calendar-action-bar' testId='calendar'>
         {props.children}
         {props.waitlistEntryId ? null : (
            <ActionBar.PrimaryButton
               testId={'goToWaitlist'}
               label={calendarTranslationKeys.waitlist}
               onClick={handleClick}
               variant={ButtonVariant.PRIMARY}
               blockingOperation
            />
         )}
      </ActionBar>
   );
};
